module.exports = __webpack_public_path__ + "media/images/lb/809-fa7999db8ebf271c45f4a258fb0d8d77.svg";